import { render, staticRenderFns } from "./LanguageInputsRules.vue?vue&type=template&id=db8aeeac&"
import script from "./LanguageInputsRules.vue?vue&type=script&lang=ts&"
export * from "./LanguageInputsRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports